export interface TrackingConfigInterface {
    writeKey: string
}

export const trackingConfig: TrackingConfigInterface = {
    writeKey: process.env.REACT_APP_SEGMENT_WRITE_KEY as string
}
